export type TileRoleLabel = 'Administrator' | 'Manager' | 'Teamleitung' | 'Mitarbeiter';

const ROLE_LABELS: Record<string, TileRoleLabel> = {
  admin: 'Administrator',
  manager: 'Manager',
  teamlead: 'Teamleitung',
  employee: 'Mitarbeiter',
};

export interface ProfileTile {
  initials: string;
  name: string;
  roleLabel: TileRoleLabel | '';
}

interface TileSource {
  firstName?: string;
  lastName?: string;
  email?: string;
}

/** Kürzel (zwei Buchstaben), Name und Rolle für die Profil-Kachel im Fuß der Seitenleiste. */
export function buildProfileTile(
  source: TileSource | null,
  hasClaim: (claim: string) => boolean
): ProfileTile {
  return {
    initials: initialsOf(source),
    name: nameOf(source),
    roleLabel: roleLabelOf(hasClaim),
  };
}

function roleLabelOf(hasClaim: (claim: string) => boolean): TileRoleLabel | '' {
  const role = Object.keys(ROLE_LABELS).find((r) => hasClaim(r));
  return role ? ROLE_LABELS[role] : '';
}

function nameOf(source: TileSource | null): string {
  const full = [source?.firstName, source?.lastName].filter(Boolean).join(' ');
  return full || source?.email?.split('@')[0] || '';
}

function initialsOf(source: TileSource | null): string {
  if (source?.firstName && source.lastName) {
    return (source.firstName.charAt(0) + source.lastName.charAt(0)).toUpperCase();
  }
  const local = source?.email?.split('@')[0];
  if (!local) return '?';
  const parts = local.split(/[._-]/).filter(Boolean);
  if (parts.length >= 2) return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  return local.substring(0, 2).toUpperCase();
}
